<template>
	<!-- 
		StorageFileUploader
		V.1.0

		@Author Daniel Lepe 2025
	-->
	<b-row class="ui-storage-file-uploader" align-v="center">
		
		<b-col v-if="isProcessing">
			<spinner></spinner>
		</b-col>

		<b-col cols="12" v-else>

			<label v-if="label" :for="workingId">
                {{ computedLabel }}
            </label>

			<!-- <div v-if="value" class="d-flex align-items-center"> -->
				<b-input-group v-if="value">
					<b-form-input :value="value" disabled></b-form-input>
					<b-input-group-append>
						<b-button variant="info" size="sm" @click="openInNewTab">
							<i class="fa fa-external-link"></i>
						</b-button>
						<b-button variant="danger" size="sm" @click="askIfCleansImg">
							<i class="fa fa-times"></i>
						</b-button>
					</b-input-group-append>
				</b-input-group>
			<!-- </div> -->

			<!-- <input v-else-if="displayingInput" type="file" :id="workingId" @change="fileUpdate($event)" :disabled="readonlyAllowed" :accept="accept"/> -->
			<b-form-file v-else-if="displayingInput" :id="workingId" :disabled="readonlyAllowed" :accept="accept" @change="fileUpdate($event)" :label="computedLabel"   drop-placeholder="Suélta el archivo..." />

		</b-col>
	</b-row>
</template>

<script>
	import _ from "lodash";
	import moment from "moment";
	import axios from "axios";
	import swal from "sweetalert";
	
	const portaLocatedImg = "https://supereasy1.com/archivosSubidos/receta/"

	moment.locale("es");

	export default {
		data() {
			return {
				hasBeenProcessed: false,
				file: null,
				displayingInput: true,
				isProcessing: false,
				workingId: null,
			};
		},

		props: {
			setBusy: {
				type: [Function, Object],
				default: null,
			},
			setUnBusy: {
				type: [Function, Object],
				default: null,
			},
			label: {
				type: [Number, String],
				default: null,
			},
			value: {
				type: [Number, String],
				default: null,
			},
			id: {
				type: [Number, String],
				default: null,
			},
			readonly: {
				type: [Number, String, Boolean],
				default: false,
			},
			allowPdf: {
				type: [Number, String, Boolean],
				default: true,
			},
		},

		computed: {
			storageURI() {
				return this.allowPdf ? "https://api.supereasy.mx/storage/upload/file" :  "https://api.supereasy.mx/storage/upload/picture";
			},
			readonlyAllowed() {
				if (!!this.readonly) return this.readonly;
				else return null;
			},
			computedLabel() {
				return !!this.label ? this.label : "Label";
			},
			accept() {
				if (this.allowPdf) {
					return "application/pdf, image/png, image/jpeg, image/jpg";
				} else {
					return "image/png, image/jpeg, image/jpg";
				}
			},
		},

		methods: {
			openInNewTab() {
				if (this.value) {
					window.open(this.value, '_blank');
				}
			},
			async askIfCleansImg(){
				let askResponse = await swal({
					icon: 'info',
					title: '¿Seguro que deseas continuar?',
					buttons: {
						cancel: 'Cancelar',
						danger: 'Si, borrar la imágen'
					}
				})
				console.log("askResponse", askResponse)
				if(askResponse == 'danger'){
					// const response = axios.delete((this.value.replace('render', 'delete')))
					this.$emit('input', null)
				}
			},
			fileUpdate($event) {
				if ($event.srcElement.files[0])
					this.file = $event.srcElement.files[0];
				if (this.file != null && this.file.size > 6 * 1024 * 1024) {
					swal(
						"Espera un momento",
						"La imágene debe ser menor de 6 MB",
						"info"
					).then(() => {
						this.file = null;
						this.refresh();
					});
				} else if (this.file != null && this.file.size) {
					this.tryUpload();
				}
			},
			triggerModelUpdate($event) {
				this.$emit("input", $event.target.value);
			},
			tryUpload() {
				this.isProcessing = true;
				var data = new FormData();
				if(this.allowPdf)
					data.append("file", this.file, this.file.name);
				else	
					data.append("imagen", this.file, this.file.name);
				if (typeof this.setBusy == "function") this.setBusy();
				axios
					.post(this.storageURI, data, {
						headers: {
							accept: "application/json",
							"Content-Type": `multipart/form-data; boundary=${data._boundary}`,
						},
					})
					.then((r) => {
						console.log("r", r);
						setTimeout(()=>{
							this.isProcessing = false;
						}, 150)
						if (typeof this.setUnBusy == "function") this.setUnBusy();
						if (r.status) {
							this.hasBeenProcessed = true;
							this.$emit("input", r.data["url"]);
						}
					})
					.catch((e) => {
						this.isProcessing = false;
						if (typeof this.setUnBusy == "function") this.setUnBusy();
						alert(
							"El servidor a cerrado la conexión, por favor intenta con imágenes mas pequeñas."
						);
					});
			},
			refresh() {
				this.displayingInput = false;
				this.isProcessing = false;
				setTimeout(() => {
					this.displayingInput = true;
				}, 50);
			},
		},

		beforeMount() {
			if (!this.id) {
				this.workingId = _.uniqueId("ui-storage-file-uploader-");
			} else {
				this.workingId = this.id;
			}
		}
		
	};
</script>

<style lang="less" scoped>

</style>
